import styled, {css} from "styled-components"

import {H1} from "@irati/ui/src/Typography"

export default styled(H1)`
  ${({theme}) => css`
    color: ${theme.colors.utility.white};
    text-shadow: 1px 2px 5px rgba(0,0,0,0.1);
  `}
`
